import { createApp } from 'vue'
import App from './App.vue'
import router from './router/router.js'
import i18n from './assets/functions/i18n.js'
import SmoothScroll from './assets/functions/smooth-scroll'
import '@/assets/css/main.css'

import 'flag-icons/css/flag-icons.min.css'

const app = createApp(App)
app.use(router)
app.use(i18n)
app.use(SmoothScroll)
app.mount('#app')
